const $window = $(window);
const breakPoint = 767;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();

//ローディング
import {loading} from "../include/module";
loading();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//SPヘッダーの開閉
import {spHeaderToggle} from "../include/module";
spHeaderToggle();

// アニメーション
const scrollAnimationFire = () =>{
  $(".js-ScrollAnimation").each(function(){

    var animationFlag = false;
    var $target = $(this);
    var number = $target.data('number');

    $(window).on('load scroll' , function() {
      setTimeout(function(){
        var winScroll = $(window).scrollTop();
        var winHeight = $(window).height();
        var scrollPositon;
        var oddMoveX;
        var evenMoveX;

        if(windowWidth > breakPoint){
          scrollPositon = winScroll + winHeight - winHeight / 3;
          oddMoveX = '-100px';
          evenMoveX = '100px';
        }else{
          scrollPositon = winScroll + winHeight - winHeight / 4;
          oddMoveX = '-10vw';
          evenMoveX = '10vw';
        }

        if($target.offset().top < scrollPositon) {
          if(!animationFlag) {

            animationFlag = true;

            if(number === 'odd'){
              $target.children('div').velocity({ translateX: oddMoveX, opacity: 1 }, { duration: 600, easing: 'easeOutBack', loop: false });
            }else{
              $target.children('div').velocity({ translateX: evenMoveX, opacity: 1 }, { duration: 600, easing: 'easeOutBack', loop: false });
            }

            setTimeout(function(){
              $target.addClass('animated');
            },650);

          }
        }
      },100);
    });
  });
};
scrollAnimationFire();

//YouTubeのモーダル
const youtubeModal = () => {
  const $modal = $('.idx-Movie_Modal');
  const $content = $('.idx-Movie_Modal-Content');
  const $youtube = $('.js-Youtube');
  // open
  $(window).on('load', function(){
    setTimeout( () => {
      const dataID = $modal.attr('data-youtube');
      //iframe append
      // $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?autoplay=1&amp;loop=0&amp;controls=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;iv_load_policy=3&amp;enablejsapi=1 frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;
    }, 1200);
  });
  //close
  $('.idx-Movie_Modal-Overlay,.idx-Movie_Modal-Close').on('click', function(){
    $modal.stop().fadeOut(400, function(){
      $content.children('iframe').remove();
    });
  });
};

const setCookie = () =>{
  if (!$.cookie('modal')) {
    $.cookie('modal', 1, {expires: 1});
  }
};
if($.cookie("modal")){}else{
  youtubeModal();
  setCookie();
}

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();


// WEBPACK FOOTER //
// ./src/assets/js/index/script.js